import { useQueryParam } from '../../hooks/useQueryParam';
import { Tabs } from '../../components/ui/tabs';
import { GeneralSettingsTab } from './GeneralSettingsTab';
import { SubscriptionTab } from './SubscriptionTab';

export function SettingsPage() {
	const [tab, setTab] = useQueryParam('tab', 'general');

	return (
		<div className="mx-auto max-w-[var(--content-max)] px-4 pt-6 pb-20 sm:px-6 md:px-8 md:pt-8">
			<div className="mb-6">
				<h1 className="mb-2 text-2xl font-medium leading-tight -tracking-[0.02em] text-text-1 sm:text-3xl">
					Settings
				</h1>
				<p className="text-base text-text-3">
					Manage your organization settings and preferences.
				</p>
			</div>

			<div className="mb-6">
				<Tabs
					value={tab}
					onChange={setTab}
					items={[
						{ value: 'general', label: 'General' },
						{ value: 'subscription', label: 'Subscription' },
					]}
				/>
			</div>

			{tab === 'general' && <GeneralSettingsTab />}
			{tab === 'subscription' && <SubscriptionTab />}
		</div>
	);
}
